export enum BidType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum BidStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CONTACTED = 'CONTACTED'
}

export interface Bid {
  inquiry_id: string
  order_id: string
  tranche_size: number
  valuation: number
  type: BidType
  status: BidStatus
  project_id: string
  project_name: string
  offered_fdv: number
  asset_type: string
  logo: string
  created_at: string
  updated_at: string
}

export interface BidsListResponse {
  page: number
  items: number
  total: number
  data: Bid[]
}

export interface BidsQueryParams {
  order_id?: string
  type?: BidType
  limit?: number
  offset?: number
}

export interface BidsApiResponse {
  success: boolean
  data: BidsListResponse
  error?: string
}